// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cst3","newExpiryDate":"styles_newExpiryDate__2Tynn","footer":"styles_footer__2tlhw"};